export default {
  v: '5.6.3',
  fr: 24,
  ip: 0,
  op: 48,
  w: 64,
  h: 64,
  nm: '64x64',
  ddd: 0,
  assets: [
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: '左上',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [80, 80, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'rc',
              d: 1,
              s: { a: 0, k: [80, 64], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: '矩形路径 1',
              mn: 'ADBE Vector Shape - Rect',
              hd: false
            },
            {
              ty: 'tm',
              s: {
                a: 1,
                k: [
                  { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [50] },
                  { t: 48, s: [50] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [85] },
                  { t: 48, s: [85] }
                ],
                ix: 2
              },
              o: {
                a: 1,
                k: [
                  { i: { x: [0.25], y: [0.992] }, o: { x: [0.818], y: [0.018] }, t: 0, s: [45] },
                  { t: 48, s: [405] }
                ],
                ix: 3
              },
              m: 1,
              ix: 2,
              nm: '修剪路径 1',
              mn: 'ADBE Vector Filter - Trim',
              hd: false
            },
            {
              ty: 'st',
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 4, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: '描边 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false
            }
          ],
          ip: 0,
          op: 48,
          st: 0,
          bm: 0
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: '右下',
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [80, 80, 0], ix: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1 },
            s: { a: 0, k: [100, 100, 100], ix: 6 }
          },
          ao: 0,
          shapes: [
            {
              ty: 'rc',
              d: 1,
              s: { a: 0, k: [80, 64], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: '矩形路径 1',
              mn: 'ADBE Vector Shape - Rect',
              hd: false
            },
            {
              ty: 'tm',
              s: {
                a: 1,
                k: [
                  { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] },
                  { t: 48, s: [0] }
                ],
                ix: 1
              },
              e: {
                a: 1,
                k: [
                  { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [35] },
                  { t: 48, s: [35] }
                ],
                ix: 2
              },
              o: {
                a: 1,
                k: [
                  { i: { x: [0.252], y: [0.998] }, o: { x: [0.817], y: [0.02] }, t: 0, s: [45] },
                  { t: 48, s: [405] }
                ],
                ix: 3
              },
              m: 1,
              ix: 2,
              nm: '修剪路径 1',
              mn: 'ADBE Vector Filter - Trim',
              hd: false
            },
            {
              ty: 'st',
              c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
              o: { a: 0, k: 100, ix: 4 },
              w: { a: 0, k: 4, ix: 5 },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: '描边 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false
            }
          ],
          ip: 0,
          op: 48,
          st: 0,
          bm: 0
        }
      ]
    }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: '空 2',
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [33, 31, 0], ix: 2 },
        a: { a: 0, k: [51.5, 50, 0], ix: 1 },
        s: { a: 0, k: [27.024, 26.214, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 48,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 0,
      nm: 'loading合成-2秒',
      parent: 1,
      refId: 'comp_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [47.8, 53.815, 0], ix: 2 },
        a: { a: 0, k: [80, 80, 0], ix: 1 },
        s: { a: 0, k: [185.019, 190.741, 100], ix: 6 }
      },
      ao: 0,
      w: 160,
      h: 160,
      ip: 0,
      op: 48,
      st: 0,
      bm: 0
    }
  ],
  markers: []
}



// WEBPACK FOOTER //
// ./packages/dof-spinner/colmo_rect.js